module.exports = __webpack_public_path__ + "static/media/1 7 leg skeelton braided.1280x1799.982b1aba.webp";